/*
  content-guard -- makes casual copying of the storefront harder: no right-click
  menu, no long-press "Save image" on phones, no image dragging, no text
  selection or copy outside form fields, and the usual DevTools / view-source /
  save-page shortcuts swallowed. It is a deterrent only: anyone who disables
  JavaScript or types view-source: in the address bar still sees everything.
  Form fields (search, email, discount codes) keep working normally.
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var css =
    'body{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}' +
    'input,textarea,select,[contenteditable],[contenteditable] *{-webkit-user-select:text;user-select:text;-webkit-touch-callout:default}' +
    'img,video,picture{-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function isField(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('input,textarea,select,[contenteditable]');
  }

  document.addEventListener('contextmenu', function (e) {
    if (!isField(e.target)) e.preventDefault();
  }, true);

  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO' || t.tagName === 'A')) e.preventDefault();
  }, true);

  ['copy', 'cut', 'selectstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!isField(e.target)) e.preventDefault();
    }, true);
  });

  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    var mod = e.ctrlKey || e.metaKey;
    var blocked =
      k === 'f12' ||
      (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c' || k === 'k')) ||
      (e.metaKey && e.altKey && (k === 'i' || k === 'j' || k === 'c' || k === 'u')) ||
      (mod && !e.shiftKey && (k === 'u' || k === 's' || k === 'p'));
    if (blocked) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
